import React, { useContext } from "react";
import { Link } from "react-router-dom";
import classNames from "classnames/bind";

//Context
import { UserContext } from "state/user/userContext";
import { GlobalContext } from "state/global/globalContext";

//Component
import Avatar from "components/shared/Avatar";
import ProfilePicture from "components/shared/ProfilePicture";

import styles from "./style.module.scss";

import { request } from "utils/request";

const Header = () => {
  //Use context
  const { state, dispatch } = useContext(UserContext);
  const { isToggle, setIsToggle } = useContext(GlobalContext);
  //const
  const { first_name, last_name, token, email } = state;
  const level = state && state.user && state.user.level;
  console.log(level);

  const logOut = () => {
    request
      .post("/api/users/logout.json", null, {
        params: {
          _token: token,
        },
      })
      .then((res) => {
        if (res?.data.state) {
            localStorage.removeItem("AppInstalled")
          dispatch({
            type: "logOut",
          });
        }
      });
  };

  return (
    <div className={styles.header}>
      <div className={styles.header_rightSection}>
        <div
          className={classNames(
            styles.header_items_hamburgerMenu,
            isToggle && styles.header_items_hamburgerMenu__on
          )}
          onClick={() => {
            setIsToggle(!isToggle);
          }}
        >
          <div className={styles.bar1}></div>
          <div className={styles.bar2}></div>
          <div className={styles.bar3}></div>
        </div>
        <div className={styles.header_items}>
          <Link to="/notification">
            <i className="icon-notification color-gray"/>
          </Link>
        </div>
      </div>

      <div className={styles.header_profile}>
        <Link to="/profile-settings">
          <div className={styles.header_profile_avatar}>
            <ProfilePicture
              userLevel={level}
              image={<Avatar email={email} />}
            />
          </div>
        </Link>
        <span
          className={styles.header_profile__name}
        >{`${first_name} ${last_name}`}</span>
        <div onClick={logOut} className={styles.header_profile__logout}>
          <i className="icon-power-button color-gray"/>
        </div>
      </div>
    </div>
  );
};
export default Header;
